import { render, staticRenderFns } from "./NumberOfOrdersByPaymentPage.vue?vue&type=template&id=071c0d4b&scoped=true&"
import script from "./NumberOfOrdersByPaymentPage.vue?vue&type=script&lang=js&"
export * from "./NumberOfOrdersByPaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./NumberOfOrdersByPaymentPage.vue?vue&type=style&index=0&id=071c0d4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071c0d4b",
  null
  
)

export default component.exports